import { Component, Input } from '@angular/core';
import { EnvironmentVariablesService } from '@kenv';
import { productDisplayName, ThemeService } from '@kservice';
import { Product } from '@ktypes/enums';

@Component({
  selector: 'kp-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss'],
})
export class LoginHeaderComponent {
  @Input() signup = false;
  @Input() skipAnimationIntro = false;
  productName = productDisplayName;
  isPurposeful = this._environmentVariablesService.product === Product.purposeful;

  constructor(private _environmentVariablesService: EnvironmentVariablesService, public themeService: ThemeService) {}
}
